import Swiper from "swiper";
import { A11y, Autoplay } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".empowered-by-block").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay],
    autoplay: {
      delay: 2000,
      pauseOnMouseEnter: true,
    },
    loop: true,
    speed: 1000,
    slidesPerView: 2,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1280: {
        slidesPerView: 5,
      },
    },
  });
});
